import React from 'react';

import HasRecording from 'assets/images/svgs/Recording/ico_record.svg';
import HasRecordingBlack from 'assets/images/svgs/Recording/ico_record_black.svg';

type Props = { highlighted: boolean; size: number };

function RecordedSingleRecording({ highlighted, size }: Props) {
    return highlighted ? (
        <HasRecordingBlack width={size} height={size} />
    ) : (
        <HasRecording width={size} height={size} />
    );
}

export default RecordedSingleRecording;
